import moment from 'moment';
import { clientFeedbackTableColumns } from '../../constants/tableColumns';
import useClientFeedbackActions from '../../hooks/APIHooks/appointments/useClientFeedbackActions';
import useCheckUserFeaturePermissions from '../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../CommonComps/Tables/AcademiaTable';
import PageHeader from '../CommonComps/Titles/PageHeader';

const ShowAllClientFeedbacks = () => {
  // integration of API hooks here
  const { getClientFeedbackListHandler } =
    useClientFeedbackActions('clientFeedbackList');

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions(
    'clientFeedback',
    true
  );

  console.log(
    'CLIENT FEEDBACK LIST: ',
    getClientFeedbackListHandler.data?.data,
    featureBasedPermissions
  );

  // rendering show all client feedbacks section component here
  return (
    <section>
      {getClientFeedbackListHandler.isLoading ||
      !featureBasedPermissions?.includes('READ') ? (
        <AcademiaLoading />
      ) : getClientFeedbackListHandler.isSuccess ? (
        <>
          <PageHeader headerText='All Client Feedbacks' />

          <AcademiaTable
            data={getClientFeedbackListHandler.data.data.map((feedback) => ({
              ...feedback,
              created_at: moment(feedback.created_at).format('DD-MM-YYYY'),
            }))}
            columns={clientFeedbackTableColumns}
            notFoundMessage='No client feedback found!'
          />
        </>
      ) : getClientFeedbackListHandler.isError ? (
        <AcademiaNotFound message='Failed to load client feedback data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllClientFeedbacks;
